import { createContext, useContext } from 'react';
import { noop } from 'lodash';
import { DragAndDropContextState, DragAndDropOrientation } from './types';

const defaultDragAndDropState: DragAndDropContextState = {
  draggedCardId: null,
  draggedOverCardId: null,
  position: null,
  setDraggedCardId: noop,
  setDraggedOverCard: noop,
  resetState: noop,
  orientation: 'vertical' satisfies DragAndDropOrientation,
};

export const DragAndDropContext = createContext<DragAndDropContextState>({
  ...defaultDragAndDropState,
});

export const useDragAndDropContext = () => useContext(DragAndDropContext);
